var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97402 15.293L9.99902 13.468L14.024 15.293L14.399 14.918L9.99902 4.29297L5.59902 14.918L5.97402 15.293ZM9.99902 20.293C8.61569 20.293 7.31569 20.0305 6.09902 19.5055C4.88236 18.9805 3.82402 18.268 2.92402 17.368C2.02402 16.468 1.31152 15.4096 0.786523 14.193C0.261523 12.9763 -0.000976562 11.6763 -0.000976562 10.293C-0.000976562 8.90964 0.261523 7.60964 0.786523 6.39297C1.31152 5.1763 2.02402 4.11797 2.92402 3.21797C3.82402 2.31797 4.88236 1.60547 6.09902 1.08047C7.31569 0.555469 8.61569 0.292969 9.99902 0.292969C11.3824 0.292969 12.6824 0.555469 13.899 1.08047C15.1157 1.60547 16.174 2.31797 17.074 3.21797C17.974 4.11797 18.6865 5.1763 19.2115 6.39297C19.7365 7.60964 19.999 8.90964 19.999 10.293C19.999 11.6763 19.7365 12.9763 19.2115 14.193C18.6865 15.4096 17.974 16.468 17.074 17.368C16.174 18.268 15.1157 18.9805 13.899 19.5055C12.6824 20.0305 11.3824 20.293 9.99902 20.293ZM9.99902 18.293C12.2324 18.293 14.124 17.518 15.674 15.968C17.224 14.418 17.999 12.5263 17.999 10.293C17.999 8.05964 17.224 6.16797 15.674 4.61797C14.124 3.06797 12.2324 2.29297 9.99902 2.29297C7.76569 2.29297 5.87402 3.06797 4.32402 4.61797C2.77402 6.16797 1.99902 8.05964 1.99902 10.293C1.99902 12.5263 2.77402 14.418 4.32402 15.968C5.87402 17.518 7.76569 18.293 9.99902 18.293Z",
    fill: "url(#paint0_linear_401_698)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_698",
    x1: -0.363844,
    y1: 10.7125,
    x2: 20.325,
    y2: 10.7125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantNavigation);
export default __webpack_public_path__ + "static/media/assistant_navigation.5cd8b9f954ebd8a7d8ab97196a4779fa.svg";
export { ForwardRef as ReactComponent };